import { EVENT_ARTICLES_ACTIONS, EventArticlesStateInterface } from "../actions/event-articles.actions";

const initialState: EventArticlesStateInterface = {
  eventArticles: [],
  currentEventArticle: null,
};

export function eventArticlesReducer(state: EventArticlesStateInterface = initialState, action) {
  switch (action.type) {
    case EVENT_ARTICLES_ACTIONS.SET_EVENT_ARTICLES:
      return Object.assign([], action.payload);

    case EVENT_ARTICLES_ACTIONS.SET_CURRENT_EVENT_ARTICLE:
      state.currentEventArticle = action.payload;
      return Object.assign([], state);

    case EVENT_ARTICLES_ACTIONS.UPDATE_EVENT_ARTICLE:
      state.eventArticles.forEach((eventArticle, index) => {
        if (eventArticle.id === action.payload) {
          state[index].isContribued = true;
        }
      });
      return Object.assign([], state);

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/store/reducers/event-articles.reducer.ts